import React, { Component } from 'react';
import { connect } from 'react-redux';
import "react-select/dist/react-select.css";
import "react-virtualized-select/styles.css";
import VirtualizedSelect from "react-virtualized-select";


class MCFilterDropdownComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: []
    };
  }

  handleChange = (value) => {
    this.setState({ selectedOptions: value });
    this.props.onHandleFilter(value);
  };

  render() {
    const {placeHolderText,filterOptions} = this.props;

    return (

      <VirtualizedSelect options={filterOptions}
          placeholder={placeHolderText}
          classNamePrefix="react-select"
          multi
          clearable={true}
          autoFocus={true}
          onChange={this.handleChange}
          value={this.state.selectedOptions}
            labelKey='name'
            valueKey='name'
            />

    );
  }
}

export const MCFilterDropdown = connect(({ dispatch }) => ({
  dispatch,
}))(MCFilterDropdownComponent);


// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/MCFilterDropdown.js